const value = import.meta.env.VITE_TEST_AUTH_URL
let testAuthenticationUrl: string | undefined
if (value) {
	const url = new URL(value)
	if (
		!import.meta.env.DEV ||
		url.protocol !== "http:" ||
		!["localhost", "127.0.0.1"].includes(url.hostname) ||
		url.username ||
		url.password ||
		url.pathname !== "/" ||
		url.search ||
		url.hash
	) {
		throw new Error("Test authentication requires a local development frontend.")
	}
	testAuthenticationUrl = url.origin
}

export const googleAuthorizationUrl = testAuthenticationUrl
	? new URL("/google/authorize", testAuthenticationUrl).href
	: "https://accounts.google.com/o/oauth2/v2/auth"
